import * as yup from "yup";

export const DefaultIndexOrderSettingsSchema = yup.object({
  index_order: yup.array().of(
    yup.object().shape({
      index_order: yup.array().of(
        yup.object().shape({
          order: yup
            .number()
            .nullable()
            .test(
              "invalid-index_order",
              "You can't duplicate order",
              (value, testContext) => {
                // testContext.from[1] selected to get all the index order list related to a application
                const list = [];
                testContext.from[1].value.index_order.find((index) => {
                  if (
                    index.order &&
                    typeof value === "number" &&
                    index.order === value
                  ) {
                    list.push(index);
                  }
                });

                if (list.length > 1) {
                  return false;
                }
                return true;
              },
            ),
        }),
      ),
    }),
  ),
});

export default {
  DefaultIndexOrderSettingsSchema,
};
